import React from 'react';
import { Grid } from 'semantic-ui-react';
import Form_express from './Form_express';
import Boxdispach from '../../../components/Micuentacardboxs/Boxdispach';


const Express = (props) => {



  return (  
  
    <Grid celled='internally'  id='expresscuentaContent'>
      <h2>Envío Express</h2>
    <Grid.Row> 
    {/* <Grid.Column  computer={3} mobile={16} tablet={16}  id='expressContainer' >
   <Button   color="primary"
            variant="contained">Mis Direcciones</Button>
    </Grid.Column> */}
    <Grid.Column  computer={9} mobile={16} tablet={16} className="dash-container-colmun" >
    <Form_express/>
    </Grid.Column>
    <Grid.Column  computer={7} mobile={16} tablet={16} className="dash-container-colmun" >
    {/* <Map_marks></Map_marks> */}
    <Boxdispach></Boxdispach>
    </Grid.Column>
    </Grid.Row>
    
  </Grid>

    ); 

  };

export default Express;
